import {Component, ElementRef, QueryList, ViewChildren} from '@angular/core';
import {AlertController, NavParams, ViewController} from 'ionic-angular';

import {GestaoPcaService} from '../../../../providers/gestao-pca-service';
import {LicitacaoService} from '../../../../providers/licitacao-service';
// import 'highcharts/adapters/standalone-framework.src';

const Highcharts = require('highcharts');

//require('highcharts/modules/exporting')(Highcharts);

declare var require: any;

@Component({
  selector: 'page-modal-pv-licitacao',
  templateUrl: 'modal-pv-licitacao.html',
  providers: [
    LicitacaoService
  ]
})
export class ModalPreVisualizarLicitacaoPage {
  @ViewChildren('chart') public charts: QueryList<ElementRef>;

  private chartEl: ElementRef;
  private _chart: any;
  titulo: any;
  isJurisdicionado: any;
  listaDados: any; //listaDados: any[];
  listaDadosRegra2: any = [];
  listaDadosRegra2Aux: any = [];
  dataGeracao: any;
  loading: boolean = true;
  shownGroup: any = [];
  shownGroupRegra8: any = [];
  shownGroupRegra9: any = [];

  constructor(private viewCtrl: ViewController,
    public navParams: NavParams,
    public licitacaoService: LicitacaoService,
    public alertCtrl: AlertController,
    public gestaoPcaService: GestaoPcaService) {

    this.dataGeracao = new Date();

    this.listarDados();
  }

  listarDados() {
    this.licitacaoService.obterDadosPrevisualizacao().subscribe(
      data => {
        this.listaDados = data;

        if (data != null &&
          data.analiseLicitacaoRegra2 != null &&
          data.analiseLicitacaoRegra2.modalidades != null &&
          data.analiseLicitacaoRegra2.modalidades.length > 0) {

          this.listaDadosRegra2Aux = data.analiseLicitacaoRegra2.modalidades.map((elem) => ([elem.descricao, elem.valorTotal]));

          for (let i = 0; i < this.listaDadosRegra2Aux.length; i++) {
            this.listaDadosRegra2.push({
              name: this.listaDadosRegra2Aux[i][0],
              y: this.listaDadosRegra2Aux[i][1]
            });
          }
        }

        this.loading = false;
      }, error => {
        console.log("erro: " + error);
        this.loading = false;
      }
    );
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }

  //  #region Métodos do Accordion
  toggleGroup(group) {
    if (this.isGroupShown(group)) {
      let index = this.shownGroup.indexOf(group);
      this.shownGroup.splice(index, 1);
    } else {
      this.shownGroup.push(group);
    }

    if (group == 30) {
      this.carregarGrafico();
    }
  }

  isGroupShown(group) {
    return this.shownGroup.indexOf(group) != -1;
  };

  toggleGroupRegra8(group) {
    if (this.isGroupShownRegra8(group)) {
      let index = this.shownGroupRegra8.indexOf(group);
      this.shownGroupRegra8.splice(index, 1);
    } else {
      this.shownGroupRegra8.push(group);
    }
  }

  isGroupShownRegra8(group) {
    return this.shownGroupRegra8.indexOf(group) != -1;
  };

  toggleGroupRegra9(group) {
    if (this.isGroupShownRegra9(group)) {
      let index = this.shownGroupRegra9.indexOf(group);
      this.shownGroupRegra9.splice(index, 1);
    } else {
      this.shownGroupRegra9.push(group);
    }
  }

  isGroupShownRegra9(group) {
    return this.shownGroupRegra9.indexOf(group) != -1;
  };

  formatarPorcentagem(valor) {
    let valorString = valor.toString();

    if (valorString.indexOf('.') != -1) {
      let tamanhoAntesDaVirgulas = valorString.indexOf('.') + 1;
      let numeroDeCasasDecimais = 2;
      valorString = valorString.substr(0, tamanhoAntesDaVirgulas + numeroDeCasasDecimais);
    }

    return valorString.replace('.', ',') + "%";
  }

  formatarValorNumerico(valor) {
    let valorFormatado = new Intl.NumberFormat('pt-BR',
      {
        style: 'currency',
        currency: 'BRL'
      }).format(valor);

    return valorFormatado.substr(2, valorFormatado.length).replace('$', '-');
  }

  formatarZeroEsquerda(valor) {
    return valor.replace(/^0+(?!\.|$)/, '');
  }

  carregarGrafico() {

    let opts: any = {
      title: { text: 'Visão Gerencial das Licitações Realizadas' },
      credits: {
        enabled: false
      },
      yAxis: {
        min: 0,
        title: {
          text: 'Volume de Recursos'
        }
      },
      xAxis: {
        type: 'category',
        labels: {
          style: {
            fontSize: '9px',
            fontFamily: 'Verdana, sans-serif'
          }
        }
      },
      tooltip: {
        formatter: function () {
          var seriesData = this.series.data;

          var total = 0;
          for (var i = 0; i < seriesData.length; i++) {
            total += seriesData[i].y
          }

          return '<span style="font-size:13px">' + this.series.data[this.x].name + '</span><br><br/>' +
            '<b>' + (100 * this.y / total).toFixed(2) + '%</b> do total<br/><br/>' +
            '<span style="color:' + this.color + '">Valor (R$)</span>: <b>' + Highcharts.numberFormat(this.y, 2, ',', '.') + '</b><br/>' +
            '<span style="color:' + this.color + '">Total (R$)</span>: <b>' + Highcharts.numberFormat(total, 2, ',', '.') + '</b><br/>';
        }
      },
      legend: {
        enabled: false
      },
      plotOptions: {
        series: {
          dataLabels: {
            enabled: true,
            formatter: function () {
              var seriesData = this.series.data;

              var total = 0;
              for (var i = 0; i < seriesData.length; i++) {
                total += seriesData[i].y
              }

              return (100 * this.y / total).toFixed(2) + "%";
            }
          }
        }
      },
      series: [{
        name: 'Modalidades',
        colorByPoint: true,
        data: this.listaDadosRegra2
      }]
    };

    if (this.chartEl && this.chartEl.nativeElement) {
      opts.chart = {
        type: 'column',
        plotBackgroundColor: null,
        plotBorderWidth: 0,
        plotShadow: false,
        backgroundColor: 'transparent',
        renderTo: this.chartEl.nativeElement
      };

      this._chart = new Highcharts.Chart(opts);
    }

  }

  public ngAfterViewInit(): void {
    this.charts.changes.subscribe((comps: QueryList<ElementRef>) => {
      this.chartEl = comps.first;

      this.carregarGrafico();
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/modais/modal-pre-visualizacao/licitacao/modal-pv-licitacao.ts